import { Calendario } from "./Calendario";

export function CalendarioContainer() {
    return (
        <div className="h-full">
            <Calendario />
        </div>
    );
}
